import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CycleValidationSnapshot } from './CycleValidationSnapshot';
import { CycleReportExistsResult } from './CycleReportExistsResult';

export class RewardsValidationResource extends FBaseService {
  public async getCycleValidationSnapshot(fiId: string, cycleId: number): Promise<CycleValidationSnapshot> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/cycle-validation-snapshot?cycleId=${cycleId}`);

    const result: CycleValidationSnapshot = response.data.data;
    return result;
  }

  public async saveCycleValidationSnapshot(fiId: string, snapshot: CycleValidationSnapshot): Promise<CycleValidationSnapshot> {
    const response: AxiosResponse = await this.apiClient.put(`/api/rcx/director/${fiId}/cycle-validation-snapshot/${snapshot.id}`, snapshot);
    const result: CycleValidationSnapshot = response.data.data;
    return result;
  }

  public async doesPostingExceptionReportExist(fiId: string, cycleId: number): Promise<CycleReportExistsResult> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/report-exists/${cycleId}/Posting_Exception_Report`);

    const result: CycleReportExistsResult = response.data.data;
    return result;
  }
}

export default RewardsValidationResource;
